import React, {Component} from 'react';
import { Link } from 'react-router';
import Helmet from "react-helmet";

import GuideButton from '../../components/GuideButton';
import GuideHeader from '../../components/GuideHeader';

export default class Flushing extends Component {
  render() {
    const imageUrl = "https://blacksquare.nyc3.digitaloceanspaces.com/janes_colony/guide/guide_header_vegetative_1.jpg";
    return (
      <div>
        <Helmet
          title="Jane's Colony"
          meta={ [
            { name: "description", content: "" },
            { property: "og:title", content: ''},
            { property: "og:url", content: ''},
            { property: "og:image", content: ''},
          ] }
        />
        <GuideHeader imageUrl={imageUrl} />
        <h2>
        Flushing
        </h2>
        <p className="highlight">Timeline: 1 - 2 weeks before harvest</p>
        <p>
        At this stage in the process you’ve been regularly feeding your plants a hearty blend of nutrients. This is great and your plants will thank you, however those same nutrients will end up flavoring your final product if you keep using them up until harvest. To prevent this we’ll flush our plants with water and stop using nutrients for the home stretch. 
        </p>
        <p>
        One to two weeks before harvest you will flush your plants which means you oversaturate your plant all at once with 2 - 3x the pot size in water. For example, if you are growing in a 5 gallon pot, you’ll want to flush it with 10  - 15 gallons of water. 
        </p>
        <h3>After flushing</h3>
        <p>
        After flushing, stop using nutrients and only give your plants PH tested water for the remaining one to two weeks.  You may notice more yellowing than usual in your plants, but don’t worry your plants are almost done and a little leave damage now won’t hurt your final product. 
        </p>
        <GuideButton slugTo="harvesting" />
      </div>
    )
  }
}





// WEBPACK FOOTER //
// ./src/content/guide/two_flushing.js